import { render, staticRenderFns } from "./AdyenPaymentMethodOption.vue?vue&type=template&id=35d9b972"
import script from "./AdyenPaymentMethodOption.vue?vue&type=script&lang=js"
export * from "./AdyenPaymentMethodOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports